var _defs, _path, _g, _text, _path2, _g2, _text2, _path3, _g3, _text3, _g4, _text4, _g5, _text5, _g6, _text6, _path4, _text7, _g7, _g8, _path5, _g9, _path6, _path7, _g10, _g11, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g12, _text8, _text9, _path17, _path18, _path19, _g13, _text10, _path20, _path21, _g14, _path22, _path23, _path24, _g15, _text11, _g16, _path25, _text12, _path26, _g17, _g18, _text13, _path27, _g19, _text14, _path28, _text15, _text16, _g20, _text17, _text18, _path29, _g21, _text19, _text20, _path30, _g22, _text21, _path31, _text22, _text23, _text24, _text25, _path32, _text26, _text27, _text28, _path33, _path34, _g23, _path35, _g24, _path36, _text29, _g25, _g26, _g27, _text30, _path37, _path38, _g28, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResQSlider4 = function SvgResQSlider4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 922 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider4_svg__a",
    x1: 0.954,
    x2: 0.043,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaeaea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider4_svg__b",
    x2: 1,
    y1: 1,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#efb50a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffea57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider4_svg__e",
    x1: 1.033,
    x2: 0.032,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58b3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed595b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider4_svg__f",
    x1: 1.033,
    x2: 0.032,
    y1: 0.5,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ededed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "resQ_Slider4_svg__n",
    x1: 0.527,
    x2: 0.53,
    y2: 1.078,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feda00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#fdada8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a5c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resQ_Slider4_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h125.271v14.476H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "resQ_Slider4_svg__m"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h122.274v13.476H0Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "resQ_Slider4_svg__c",
    width: 24,
    height: 24.096,
    x: 435.5,
    y: 439.843,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "i",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.059
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "i",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fdfdfd",
    d: "M0 80h918v400H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(0 174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 306,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 351,
    height: 305,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(16 204)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Templates"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M1 190a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05b5b",
    stroke: "#f05b5b",
    transform: "translate(16 222)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 15,
    fontWeight: 700,
    transform: "translate(34 252.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DFP_PM_2607"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#83e083",
    d: "M16 234h3a5 5 0 0 1 5 5v17a5 5 0 0 1-5 5h-3z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider4_svg__a)",
    stroke: "#e3e3e3",
    transform: "translate(16 285)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 15,
    fontWeight: 300,
    transform: "translate(31 315.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DFP_faiz_99"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider4_svg__a)",
    stroke: "#e3e3e3",
    transform: "translate(16 348)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 15,
    fontWeight: 300,
    transform: "translate(31 378.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "July-19-2016"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider4_svg__a)",
    stroke: "#e3e3e3",
    transform: "translate(16 411)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 322,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 15,
    fontWeight: 300,
    transform: "translate(31 441.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DFP_PM_2607"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(360 174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 306,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 559,
    height: 305,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  }))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 18,
    fontWeight: 500,
    transform: "translate(376 206)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DFP_PM_2607"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed5b58",
    d: "M361 189a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5z"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 13,
    fontWeight: 300,
    transform: "translate(790 203)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download Reports"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M775.903 202.448h7.361a.224.224 0 0 1 .208.208v1.289a.21.21 0 0 1-.208.208h-7.361a.224.224 0 0 1-.208-.208v-1.289a.21.21 0 0 1 .208-.208M779.439 201.156a.2.2 0 0 0 .291 0l3.2-3.2a.208.208 0 0 0-.145-.353h-2.346v-4.548a.21.21 0 0 0-.208-.208h-1.292a.21.21 0 0 0-.208.208v4.546h-2.35a.208.208 0 0 0-.145.353Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 11
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(374 236)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Created by "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Ashish Kumar Gupta"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(514 236)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Date"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "01/09/2024"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(598 236)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Responses"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "1,00,000"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(710 236)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Filtered Out "), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "71,234"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(828 236)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Total Qualified"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "28,766"))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M378.856 428.526a4 4 0 0 0-.667-.052 1.785 1.785 0 0 0-1.809 1.143v5.661h-1.355v-7.975h1.319l.022.921a2.11 2.11 0 0 1 1.89-1.069 1.4 1.4 0 0 1 .6.1Zm4.534 6.9a3.45 3.45 0 0 1-2.622-1.065 3.97 3.97 0 0 1-1.011-2.852v-.251a4.8 4.8 0 0 1 .45-2.119 3.53 3.53 0 0 1 1.26-1.46 3.15 3.15 0 0 1 1.754-.527 2.96 2.96 0 0 1 2.4 1.025 4.46 4.46 0 0 1 .859 2.932v.568h-5.368a2.85 2.85 0 0 0 .688 1.91 2.15 2.15 0 0 0 1.663.722 2.35 2.35 0 0 0 1.216-.295 3.1 3.1 0 0 0 .872-.781l.828.649a3.32 3.32 0 0 1-2.989 1.544m-.168-7.15a1.8 1.8 0 0 0-1.377.6 2.93 2.93 0 0 0-.688 1.684h3.97v-.1a2.6 2.6 0 0 0-.557-1.611 1.7 1.7 0 0 0-1.349-.573Zm9.441 4.887a1 1 0 0 0-.414-.859 4 4 0 0 0-1.443-.527 6.8 6.8 0 0 1-1.633-.531 2.3 2.3 0 0 1-.894-.737 1.77 1.77 0 0 1-.289-1.017 2.07 2.07 0 0 1 .824-1.659 3.2 3.2 0 0 1 2.106-.678 3.3 3.3 0 0 1 2.186.7 2.23 2.23 0 0 1 .839 1.791h-1.363a1.23 1.23 0 0 0-.472-.966 1.76 1.76 0 0 0-1.19-.405 1.84 1.84 0 0 0-1.157.324 1.02 1.02 0 0 0-.417.848.83.83 0 0 0 .388.744 4.8 4.8 0 0 0 1.4.479 7.3 7.3 0 0 1 1.644.545 2.4 2.4 0 0 1 .934.763 1.9 1.9 0 0 1 .3 1.087 2.05 2.05 0 0 1-.85 1.714 3.55 3.55 0 0 1-2.2.645 4 4 0 0 1-1.685-.339 2.74 2.74 0 0 1-1.146-.947 2.3 2.3 0 0 1-.414-1.316h1.355a1.42 1.42 0 0 0 .547 1.087 2.1 2.1 0 0 0 1.344.4A2.17 2.17 0 0 0 392.2 434a.96.96 0 0 0 .462-.837Zm11.477-2.9a6.7 6.7 0 0 1-.491 2.679 4.14 4.14 0 0 1-1.378 1.754l1.9 1.5-.959.892-2.244-1.795a4.6 4.6 0 0 1-1.113.133 4.06 4.06 0 0 1-2.234-.623 4.1 4.1 0 0 1-1.512-1.776 6.4 6.4 0 0 1-.553-2.672v-.774a6.6 6.6 0 0 1 .535-2.735 4.1 4.1 0 0 1 1.509-1.817 4.04 4.04 0 0 1 2.238-.63 4.1 4.1 0 0 1 2.267.627 4.04 4.04 0 0 1 1.505 1.8 6.7 6.7 0 0 1 .527 2.746Zm-1.406-.693a4.9 4.9 0 0 0-.751-2.923 2.5 2.5 0 0 0-2.143-1.032 2.47 2.47 0 0 0-2.091 1.021 4.74 4.74 0 0 0-.787 2.834v.789a4.88 4.88 0 0 0 .765 2.9 2.48 2.48 0 0 0 2.127 1.065 2.48 2.48 0 0 0 2.109-1 4.8 4.8 0 0 0 .769-2.864Zm10.43.929a6.6 6.6 0 0 1-2.634-1.29 2.47 2.47 0 0 1-.824-1.883 2.6 2.6 0 0 1 1.007-2.1 4 4 0 0 1 2.618-.829 4.35 4.35 0 0 1 1.959.428 3.23 3.23 0 0 1 1.333 1.184 3.03 3.03 0 0 1 .477 1.64h-1.418a1.96 1.96 0 0 0-.615-1.53 2.5 2.5 0 0 0-1.736-.557 2.55 2.55 0 0 0-1.622.461 1.54 1.54 0 0 0-.582 1.279 1.39 1.39 0 0 0 .552 1.107 5.4 5.4 0 0 0 1.882.829 8.7 8.7 0 0 1 2.08.829 3.17 3.17 0 0 1 1.113 1.058 2.7 2.7 0 0 1 .363 1.423 2.51 2.51 0 0 1-1.011 2.09 4.3 4.3 0 0 1-2.7.785 5 5 0 0 1-2.051-.424 3.46 3.46 0 0 1-1.469-1.161 2.85 2.85 0 0 1-.516-1.673h1.414a1.85 1.85 0 0 0 .716 1.544 3 3 0 0 0 1.9.56 2.75 2.75 0 0 0 1.711-.46 1.49 1.49 0 0 0 .589-1.243 1.46 1.46 0 0 0-.549-1.22 6.3 6.3 0 0 0-1.988-.852Zm8.722 3.81a1.94 1.94 0 0 0 1.267-.442 1.56 1.56 0 0 0 .6-1.106h1.282a2.5 2.5 0 0 1-.469 1.3 3.1 3.1 0 0 1-1.154.988 3.3 3.3 0 0 1-1.527.369 3.26 3.26 0 0 1-2.574-1.079 4.35 4.35 0 0 1-.956-2.974v-.229a4.8 4.8 0 0 1 .425-2.071 3.25 3.25 0 0 1 1.22-1.408 3.45 3.45 0 0 1 1.879-.5 3.17 3.17 0 0 1 2.216.8 2.88 2.88 0 0 1 .941 2.086h-1.283a1.88 1.88 0 0 0-.582-1.272 1.8 1.8 0 0 0-1.293-.5 1.89 1.89 0 0 0-1.6.748 3.53 3.53 0 0 0-.568 2.163v.258a3.46 3.46 0 0 0 .564 2.123 1.9 1.9 0 0 0 1.612.746m4.314-3.1a4.7 4.7 0 0 1 .457-2.1 3.43 3.43 0 0 1 1.274-1.445 3.45 3.45 0 0 1 1.869-.509 3.33 3.33 0 0 1 2.618 1.128 4.36 4.36 0 0 1 1 3v.1a4.8 4.8 0 0 1-.443 2.09 3.4 3.4 0 0 1-1.275 1.436 3.5 3.5 0 0 1-1.893.516 3.32 3.32 0 0 1-2.607-1.127 4.33 4.33 0 0 1-1-2.985Zm1.362.162a3.43 3.43 0 0 0 .612 2.13 1.95 1.95 0 0 0 1.637.8 1.94 1.94 0 0 0 1.641-.815 3.75 3.75 0 0 0 .608-2.281 3.42 3.42 0 0 0-.619-2.127 1.96 1.96 0 0 0-1.641-.802 1.94 1.94 0 0 0-1.619.8 3.72 3.72 0 0 0-.619 2.303Zm11.382-2.845a4 4 0 0 0-.667-.052 1.785 1.785 0 0 0-1.809 1.143v5.661h-1.355v-7.975h1.318l.022.921a2.11 2.11 0 0 1 1.89-1.069 1.4 1.4 0 0 1 .6.1Zm4.534 6.9a3.45 3.45 0 0 1-2.623-1.065 3.97 3.97 0 0 1-1.01-2.852v-.251a4.8 4.8 0 0 1 .45-2.119 3.53 3.53 0 0 1 1.26-1.46 3.15 3.15 0 0 1 1.754-.527 2.96 2.96 0 0 1 2.4 1.025 4.46 4.46 0 0 1 .859 2.932v.568H441.2a2.85 2.85 0 0 0 .685 1.905 2.15 2.15 0 0 0 1.666.727 2.35 2.35 0 0 0 1.216-.295 3.1 3.1 0 0 0 .872-.781l.828.649a3.32 3.32 0 0 1-2.989 1.544m-.168-7.15a1.8 1.8 0 0 0-1.377.6 2.93 2.93 0 0 0-.688 1.684h3.97v-.1a2.6 2.6 0 0 0-.557-1.611 1.7 1.7 0 0 0-1.349-.573Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#cfcfcf",
    strokeWidth: 0.5,
    transform: "translate(375 449.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 195,
    height: 5.032,
    stroke: "none",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 194.5,
    height: 4.532,
    x: 0.25,
    y: 0.25,
    fill: "none",
    rx: 0.75
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "M376 449.375h225v5.032H376a1 1 0 0 1-1-1v-3.032a1 1 0 0 1 1-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#resQ_Slider4_svg__b)",
    d: "M1 0h71v5.032H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1",
    transform: "translate(375 449.375)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#resQ_Slider4_svg__c)",
    transform: "translate(0 .003)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#d5d5d5",
    transform: "translate(440 444.34)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.548,
    stroke: "none",
    rx: 7.5,
    ry: 7.548
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7.548,
    fill: "none",
    rx: 7,
    ry: 7.048
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 7
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#e9483e",
    transform: "translate(373 469)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Inorganic")), /*#__PURE__*/React.createElement("text", {
    fill: "#e0aa21",
    transform: "translate(423.001 469)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Least Organic")), /*#__PURE__*/React.createElement("text", {
    fill: "#46ac1e",
    transform: "translate(573 469)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Organic")), /*#__PURE__*/React.createElement("text", {
    fill: "#ed8633",
    transform: "translate(486.999 469)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Moderately Organic")))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05b5b",
    fillRule: "evenodd",
    d: "M475.254 436.859a6.506 6.506 0 1 1 6.836-6.5 6.68 6.68 0 0 1-6.836 6.5m8.186-8.1a8.264 8.264 0 0 0-8.183-6.341h-13.678a7.952 7.952 0 1 0 0 15.884h13.679a8.154 8.154 0 0 0 8.352-7.942 7.6 7.6 0 0 0-.17-1.6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M380.743 378.944h-4.475v4.739h-1.406v-10.732h6.606v1.16h-5.2v3.671h4.475Zm3.67 4.739h-1.355v-7.972h1.355Zm-1.465-10.091a.82.82 0 0 1 .2-.56.75.75 0 0 1 .6-.229.77.77 0 0 1 .6.229.8.8 0 0 1 .205.56.78.78 0 0 1-.205.553.78.78 0 0 1-.6.221.77.77 0 0 1-.6-.221.8.8 0 0 1-.2-.553m5.105 10.091h-1.355v-11.322h1.355Zm4.006-9.907v1.935h1.479v1.054h-1.479v4.946a1.1 1.1 0 0 0 .2.719.83.83 0 0 0 .674.24 3.3 3.3 0 0 0 .645-.088v1.101a4 4 0 0 1-1.04.147 1.68 1.68 0 0 1-1.37-.553 2.4 2.4 0 0 1-.464-1.566v-4.949h-1.443v-1.051h1.443v-1.935Zm6.35 10.055a3.45 3.45 0 0 1-2.622-1.065 3.97 3.97 0 0 1-1.011-2.849v-.251a4.8 4.8 0 0 1 .45-2.119 3.53 3.53 0 0 1 1.26-1.46 3.15 3.15 0 0 1 1.754-.527 2.96 2.96 0 0 1 2.4 1.025 4.46 4.46 0 0 1 .857 2.934v.568h-5.366a2.85 2.85 0 0 0 .685 1.905 2.15 2.15 0 0 0 1.666.726 2.35 2.35 0 0 0 1.216-.295 3.1 3.1 0 0 0 .872-.781l.828.649a3.32 3.32 0 0 1-2.989 1.54m-.168-7.15a1.8 1.8 0 0 0-1.377.6 2.93 2.93 0 0 0-.688 1.684h3.97v-.1a2.6 2.6 0 0 0-.557-1.611 1.7 1.7 0 0 0-1.348-.573m8.657.251a4 4 0 0 0-.667-.052 1.785 1.785 0 0 0-1.807 1.142v5.661h-1.357v-7.972h1.318l.022.921a2.11 2.11 0 0 1 1.89-1.069 1.4 1.4 0 0 1 .6.1Zm11.667 2.852a4.76 4.76 0 0 1-.835 2.937 2.66 2.66 0 0 1-2.241 1.11 2.76 2.76 0 0 1-2.322-1.069l-.066.921h-1.245v-11.322h1.355v4.224a2.74 2.74 0 0 1 2.263-1.025 2.68 2.68 0 0 1 2.267 1.1 4.9 4.9 0 0 1 .824 3.007Zm-1.355-.155a3.7 3.7 0 0 0-.535-2.152 1.77 1.77 0 0 0-1.538-.759 1.99 1.99 0 0 0-1.926 1.253v3.45a2.04 2.04 0 0 0 1.941 1.252 1.76 1.76 0 0 0 1.516-.762 3.94 3.94 0 0 0 .542-2.282m5.654 2.057 1.846-5.975h1.45l-3.185 9.2q-.74 1.99-2.351 1.99l-.256-.022-.505-.1v-1.098l.361.03a1.8 1.8 0 0 0 1.073-.28 2.03 2.03 0 0 0 .638-1.025l.3-.811-2.827-7.884h1.479Zm7.888-2.057a4.7 4.7 0 0 1 .864-2.952 2.73 2.73 0 0 1 2.263-1.117 2.74 2.74 0 0 1 2.2.958v-4.157h1.355v11.322h-1.239l-.071-.855a2.75 2.75 0 0 1-2.263 1 2.7 2.7 0 0 1-2.237-1.132 4.75 4.75 0 0 1-.868-2.963Zm1.355.155a3.56 3.56 0 0 0 .558 2.127 1.8 1.8 0 0 0 1.538.767 1.975 1.975 0 0 0 1.882-1.167v-3.666a1.99 1.99 0 0 0-1.868-1.128 1.8 1.8 0 0 0-1.553.774 3.9 3.9 0 0 0-.556 2.293Zm10.724 4.047a3.45 3.45 0 0 1-2.623-1.065 3.97 3.97 0 0 1-1.011-2.849v-.251a4.8 4.8 0 0 1 .45-2.119 3.53 3.53 0 0 1 1.26-1.46 3.15 3.15 0 0 1 1.754-.527 2.96 2.96 0 0 1 2.4 1.025 4.46 4.46 0 0 1 .863 2.934v.568h-5.371a2.85 2.85 0 0 0 .685 1.905 2.15 2.15 0 0 0 1.666.726 2.35 2.35 0 0 0 1.22-.295 3.1 3.1 0 0 0 .872-.781l.828.649a3.32 3.32 0 0 1-2.993 1.54m-.168-7.15a1.8 1.8 0 0 0-1.377.6 2.93 2.93 0 0 0-.688 1.684h3.97v-.1a2.6 2.6 0 0 0-.557-1.611 1.7 1.7 0 0 0-1.349-.573Zm7.346 5.153 1.962-6.123h1.384l-2.841 7.972h-1.033l-2.871-7.972h1.384Zm6.122 1.849h-1.355v-7.972h1.355Zm-1.465-10.091a.82.82 0 0 1 .2-.56.75.75 0 0 1 .6-.229.77.77 0 0 1 .6.229.8.8 0 0 1 .205.56.78.78 0 0 1-.205.553.78.78 0 0 1-.6.221.77.77 0 0 1-.6-.221.8.8 0 0 1-.2-.553m6.812 9.126a1.94 1.94 0 0 0 1.267-.442 1.56 1.56 0 0 0 .6-1.106h1.279a2.5 2.5 0 0 1-.469 1.3 3.1 3.1 0 0 1-1.154.988 3.3 3.3 0 0 1-1.523.373 3.26 3.26 0 0 1-2.574-1.088 4.35 4.35 0 0 1-.956-2.974v-.228a4.8 4.8 0 0 1 .425-2.071 3.25 3.25 0 0 1 1.219-1.409 3.45 3.45 0 0 1 1.879-.5 3.17 3.17 0 0 1 2.216.8 2.88 2.88 0 0 1 .937 2.089h-1.278a1.88 1.88 0 0 0-.582-1.272 1.8 1.8 0 0 0-1.293-.5 1.89 1.89 0 0 0-1.6.748 3.53 3.53 0 0 0-.568 2.163v.258a3.46 3.46 0 0 0 .564 2.123 1.9 1.9 0 0 0 1.611.748m7.961 1.113a3.45 3.45 0 0 1-2.622-1.065 3.97 3.97 0 0 1-1.011-2.849v-.251a4.8 4.8 0 0 1 .45-2.119 3.53 3.53 0 0 1 1.26-1.46 3.15 3.15 0 0 1 1.754-.527 2.96 2.96 0 0 1 2.4 1.025 4.46 4.46 0 0 1 .857 2.934v.568h-5.365a2.85 2.85 0 0 0 .685 1.905 2.15 2.15 0 0 0 1.666.726 2.35 2.35 0 0 0 1.211-.295 3.1 3.1 0 0 0 .872-.781l.828.649a3.32 3.32 0 0 1-2.985 1.54m-.168-7.15a1.8 1.8 0 0 0-1.377.6 2.93 2.93 0 0 0-.688 1.684h3.97v-.1a2.6 2.6 0 0 0-.557-1.611 1.7 1.7 0 0 0-1.348-.573"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "m395.067 398.316 2.789 6.961 2.789-6.961h1.459v8.531h-1.125v-3.322l.105-3.586-2.8 6.908h-.86l-2.8-6.891.111 3.568v3.323h-1.121v-8.531Zm8.566 5.3a3.75 3.75 0 0 1 .367-1.669 2.73 2.73 0 0 1 1.024-1.153 2.78 2.78 0 0 1 1.491-.4 2.67 2.67 0 0 1 2.095.9 3.45 3.45 0 0 1 .8 2.385v.068a3.8 3.8 0 0 1-.354 1.661 2.7 2.7 0 0 1-1.019 1.146 2.8 2.8 0 0 1-1.513.41 2.67 2.67 0 0 1-2.089-.9 3.43 3.43 0 0 1-.8-2.373Zm1.091.131a2.7 2.7 0 0 0 .489 1.693 1.57 1.57 0 0 0 1.31.639 1.56 1.56 0 0 0 1.313-.647 2.97 2.97 0 0 0 .488-1.814 2.7 2.7 0 0 0-.5-1.69 1.57 1.57 0 0 0-1.315-.647 1.56 1.56 0 0 0-1.295.639 2.94 2.94 0 0 0-.49 1.827m11.408 0a3.77 3.77 0 0 1-.668 2.335 2.13 2.13 0 0 1-1.793.882 2.21 2.21 0 0 1-1.857-.85l-.053.733h-1v-9h1.084v3.357a2.2 2.2 0 0 1 1.811-.814 2.15 2.15 0 0 1 1.813.873 3.9 3.9 0 0 1 .659 2.391Zm-1.084-.123a2.93 2.93 0 0 0-.424-1.711 1.42 1.42 0 0 0-1.23-.6 1.59 1.59 0 0 0-1.541 1v2.734a1.64 1.64 0 0 0 1.553 1 1.41 1.41 0 0 0 1.213-.6 3.1 3.1 0 0 0 .429-1.823m3.627 3.223h-1.084v-6.34h1.084Zm-1.172-8.021a.65.65 0 0 1 .161-.445.6.6 0 0 1 .478-.182.61.61 0 0 1 .48.182.64.64 0 0 1 .164.445.62.62 0 0 1-.162.439.63.63 0 0 1-.48.176.62.62 0 0 1-.478-.176.63.63 0 0 1-.163-.439m4.084 8.021h-1.084v-9h1.084Zm4.365.117a2.77 2.77 0 0 1-2.1-.847 3.14 3.14 0 0 1-.809-2.265v-.2a3.8 3.8 0 0 1 .36-1.685 2.8 2.8 0 0 1 1.008-1.16 2.53 2.53 0 0 1 1.4-.419 2.37 2.37 0 0 1 1.922.814 3.53 3.53 0 0 1 .691 2.334v.451h-4.294a2.25 2.25 0 0 0 .548 1.515 1.72 1.72 0 0 0 1.333.577 1.9 1.9 0 0 0 .972-.232 2.4 2.4 0 0 0 .7-.621l.662.516a2.66 2.66 0 0 1-2.393 1.222m-.135-5.684a1.45 1.45 0 0 0-1.1.478 2.32 2.32 0 0 0-.551 1.339h3.176v-.082a2.07 2.07 0 0 0-.445-1.28 1.36 1.36 0 0 0-1.08-.454Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M385.7 394.847h-8.917a2.79 2.79 0 0 0-2.783 2.787v8.913a2.79 2.79 0 0 0 2.787 2.787h8.913a2.79 2.79 0 0 0 2.787-2.787v-8.917a2.79 2.79 0 0 0-2.787-2.783m1.672 11.7a1.674 1.674 0 0 1-1.672 1.672h-8.917a1.674 1.674 0 0 1-1.672-1.672v-8.917a1.674 1.674 0 0 1 1.672-1.672h8.917a1.674 1.674 0 0 1 1.672 1.672Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M478.823 406.847h-1.128v-8.531h1.128Zm7.239-3.1a3.8 3.8 0 0 1-.662 2.332 2.12 2.12 0 0 1-1.793.885 2.33 2.33 0 0 1-1.816-.732v3.053h-1.084v-8.778h.99l.053.7a2.23 2.23 0 0 1 1.84-.82 2.16 2.16 0 0 1 1.807.86 3.84 3.84 0 0 1 .665 2.4Zm-1.084-.123a2.8 2.8 0 0 0-.455-1.693 1.47 1.47 0 0 0-1.254-.621 1.59 1.59 0 0 0-1.477.873v3.029a1.6 1.6 0 0 0 1.488.867 1.47 1.47 0 0 0 1.243-.618 3.06 3.06 0 0 0 .455-1.837m6.375 3.223a2.3 2.3 0 0 1-.152-.668 2.42 2.42 0 0 1-1.8.785 2.24 2.24 0 0 1-1.538-.53 1.72 1.72 0 0 1-.6-1.345 1.79 1.79 0 0 1 .748-1.542 3.55 3.55 0 0 1 2.118-.548h1.055v-.5a1.22 1.22 0 0 0-.34-.905 1.37 1.37 0 0 0-1-.337 1.58 1.58 0 0 0-.973.293.86.86 0 0 0-.393.709h-1.09a1.5 1.5 0 0 1 .335-.912 2.3 2.3 0 0 1 .914-.7 3.1 3.1 0 0 1 1.269-.258 2.5 2.5 0 0 1 1.717.549 1.98 1.98 0 0 1 .645 1.509v2.918a3.6 3.6 0 0 0 .223 1.389v.093Zm-1.8-.826a1.9 1.9 0 0 0 .97-.264 1.6 1.6 0 0 0 .662-.686v-1.3h-.85q-1.992 0-1.992 1.166a.99.99 0 0 0 .34.8 1.3 1.3 0 0 0 .872.284Zm4.148-2.4a3.7 3.7 0 0 1 .691-2.347 2.19 2.19 0 0 1 1.811-.888 2.2 2.2 0 0 1 1.764.762v-3.301h1.086v9h-1l-.053-.68a2.2 2.2 0 0 1-1.811.8 2.17 2.17 0 0 1-1.8-.9 3.76 3.76 0 0 1-.694-2.355Zm1.084.123a2.8 2.8 0 0 0 .445 1.688 1.44 1.44 0 0 0 1.233.615 1.58 1.58 0 0 0 1.506-.926v-2.915a1.59 1.59 0 0 0-1.494-.9 1.45 1.45 0 0 0-1.242.615 3.1 3.1 0 0 0-.446 1.826Zm6.166 3.835h-.928l3.563-9.264h.926Zm10.793-8.337h-2.742v7.605h-1.119v-7.605h-2.737v-.926h6.6Zm4.348 7.605a2.3 2.3 0 0 1-.152-.668 2.42 2.42 0 0 1-1.8.785 2.24 2.24 0 0 1-1.538-.53 1.72 1.72 0 0 1-.6-1.345 1.79 1.79 0 0 1 .747-1.542 3.55 3.55 0 0 1 2.118-.548h1.056v-.5a1.22 1.22 0 0 0-.34-.905 1.37 1.37 0 0 0-1-.337 1.58 1.58 0 0 0-.973.293.86.86 0 0 0-.393.709h-1.094a1.5 1.5 0 0 1 .337-.917 2.3 2.3 0 0 1 .914-.7 3.1 3.1 0 0 1 1.269-.258 2.5 2.5 0 0 1 1.717.548 1.98 1.98 0 0 1 .646 1.515v2.918a3.6 3.6 0 0 0 .223 1.389v.093Zm-1.8-.826a1.9 1.9 0 0 0 .967-.264 1.6 1.6 0 0 0 .662-.686v-1.3h-.85q-1.992 0-1.992 1.166a.99.99 0 0 0 .34.8 1.3 1.3 0 0 0 .874.284Zm9.78-2.274a3.77 3.77 0 0 1-.668 2.335 2.13 2.13 0 0 1-1.793.882 2.21 2.21 0 0 1-1.857-.85l-.053.733h-1v-9h1.084v3.357a2.2 2.2 0 0 1 1.811-.814 2.15 2.15 0 0 1 1.813.873 3.9 3.9 0 0 1 .659 2.391Zm-1.084-.123a2.93 2.93 0 0 0-.428-1.711 1.42 1.42 0 0 0-1.23-.6 1.59 1.59 0 0 0-1.541 1v2.734a1.64 1.64 0 0 0 1.553 1 1.41 1.41 0 0 0 1.213-.6 3.1 3.1 0 0 0 .433-1.823m3.627 3.223h-1.084v-9h1.084Zm4.365.117a2.77 2.77 0 0 1-2.1-.847 3.14 3.14 0 0 1-.809-2.265v-.2a3.8 3.8 0 0 1 .36-1.685 2.8 2.8 0 0 1 1.008-1.16 2.53 2.53 0 0 1 1.4-.419 2.37 2.37 0 0 1 1.922.814 3.53 3.53 0 0 1 .686 2.332v.451h-4.289a2.25 2.25 0 0 0 .548 1.515 1.72 1.72 0 0 0 1.333.577 1.9 1.9 0 0 0 .973-.23 2.4 2.4 0 0 0 .7-.621l.662.516a2.66 2.66 0 0 1-2.394 1.222m-.135-5.684a1.45 1.45 0 0 0-1.1.478 2.32 2.32 0 0 0-.552 1.339h3.176v-.082a2.07 2.07 0 0 0-.445-1.28 1.36 1.36 0 0 0-1.078-.454Zm5.332-2.309v1.536h1.184v.84h-1.183v3.93a.88.88 0 0 0 .158.57.67.67 0 0 0 .539.19 2.6 2.6 0 0 0 .516-.07v.88a3.1 3.1 0 0 1-.832.117 1.35 1.35 0 0 1-1.1-.439 1.9 1.9 0 0 1-.369-1.248v-3.93h-1.151v-.84h1.154v-1.535Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M469.699 394.847h-8.917a2.79 2.79 0 0 0-2.783 2.787v8.913a2.79 2.79 0 0 0 2.787 2.787h8.913a2.79 2.79 0 0 0 2.787-2.787v-8.917a2.79 2.79 0 0 0-2.787-2.783m1.672 11.7a1.674 1.674 0 0 1-1.672 1.672h-8.917a1.674 1.674 0 0 1-1.672-1.672v-8.917a1.674 1.674 0 0 1 1.672-1.672h8.917a1.674 1.674 0 0 1 1.672 1.672Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M587.739 403.507v3.34h-1.125v-8.531h3.147a3.16 3.16 0 0 1 2.194.715 2.42 2.42 0 0 1 .794 1.893 2.4 2.4 0 0 1-.776 1.913 3.3 3.3 0 0 1-2.224.671Zm0-.92h2.022a2.02 2.02 0 0 0 1.383-.425 1.55 1.55 0 0 0 .48-1.227 1.6 1.6 0 0 0-.48-1.219 1.9 1.9 0 0 0-1.32-.474h-2.085Zm12.721 1.553a3.14 3.14 0 0 1-1 2.089 3.27 3.27 0 0 1-2.236.735 3 3 0 0 1-2.421-1.084 4.36 4.36 0 0 1-.911-2.9v-.82a4.9 4.9 0 0 1 .425-2.092 3.17 3.17 0 0 1 1.207-1.386 3.35 3.35 0 0 1 1.8-.483 3.08 3.08 0 0 1 2.18.759 3.18 3.18 0 0 1 .955 2.1h-1.13a2.44 2.44 0 0 0-.636-1.477 1.93 1.93 0 0 0-1.369-.457 2.01 2.01 0 0 0-1.69.8 3.66 3.66 0 0 0-.61 2.265v.826a3.76 3.76 0 0 0 .58 2.209 1.88 1.88 0 0 0 1.62.823 2.17 2.17 0 0 0 1.438-.425 2.36 2.36 0 0 0 .665-1.479Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M578.7 394.847h-8.917a2.79 2.79 0 0 0-2.783 2.787v8.913a2.79 2.79 0 0 0 2.787 2.787h8.913a2.79 2.79 0 0 0 2.787-2.787v-8.917a2.79 2.79 0 0 0-2.787-2.783m1.672 11.7a1.674 1.674 0 0 1-1.672 1.672h-8.917a1.674 1.674 0 0 1-1.672-1.672v-8.917a1.674 1.674 0 0 1 1.672-1.672h8.917a1.674 1.674 0 0 1 1.672 1.672Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05b5b",
    fillRule: "evenodd",
    d: "M500.255 385.46a6.506 6.506 0 1 1 6.836-6.5 6.68 6.68 0 0 1-6.836 6.5m8.186-8.1a8.264 8.264 0 0 0-8.183-6.341H486.58a7.952 7.952 0 1 0 0 15.884h13.679a8.154 8.154 0 0 0 8.352-7.942 7.6 7.6 0 0 0-.17-1.6"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(617.002 321.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 49.953,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 48.953,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 2.5
  }))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    fill: "#8d8d8d",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 8,
    fontWeight: 500,
    transform: "translate(624.361 327.119)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 8
  }, "Note : "), /*#__PURE__*/React.createElement("tspan", {
    y: 8,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "Duplicate IP addresses will be prohibited in a typical network "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "configuration. IP addresses are unique identifiers assigned to devices "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 28,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "on a network, and duplicate IP addresses can cause conflicts & "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 38,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "connectivity issues."))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    fill: "#424242",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 9,
    transform: "translate(632.002 311.947)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Restrict duplicate IP for entire survey"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M622.146 305.019a3.99 3.99 0 1 1-3.985 3.99 4 4 0 0 1 3.985-3.99m0-.706a4.7 4.7 0 1 0 4.7 4.7 4.69 4.69 0 0 0-4.7-4.7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M622.151 289.633h-2.5v4.314h-1.419v-10.664h3.53a4.18 4.18 0 0 1 2.772.82 2.95 2.95 0 0 1 .968 2.388 2.87 2.87 0 0 1-.535 1.736 3.2 3.2 0 0 1-1.5 1.106l2.5 4.526v.088h-1.502Zm-2.5-1.15h2.151a2.44 2.44 0 0 0 1.666-.542 1.83 1.83 0 0 0 .619-1.45 1.93 1.93 0 0 0-.585-1.516 2.5 2.5 0 0 0-1.7-.535h-2.156Zm10.901 5.61a3.46 3.46 0 0 1-2.622-1.058 3.93 3.93 0 0 1-1.011-2.831v-.249a4.76 4.76 0 0 1 .45-2.106 3.5 3.5 0 0 1 1.26-1.45 3.17 3.17 0 0 1 1.754-.524 2.97 2.97 0 0 1 2.4 1.018 4.4 4.4 0 0 1 .857 2.915v.564h-5.366a2.82 2.82 0 0 0 .685 1.893 2.15 2.15 0 0 0 1.666.721 2.36 2.36 0 0 0 1.216-.293 3.1 3.1 0 0 0 .872-.776l.828.645a3.33 3.33 0 0 1-2.989 1.531m-.168-7.1a1.8 1.8 0 0 0-1.377.6 2.9 2.9 0 0 0-.688 1.674h3.97v-.1a2.58 2.58 0 0 0-.557-1.6 1.7 1.7 0 0 0-1.349-.578Zm9.44 4.854a1 1 0 0 0-.414-.853 4 4 0 0 0-1.443-.524 6.8 6.8 0 0 1-1.633-.527 2.3 2.3 0 0 1-.894-.732 1.75 1.75 0 0 1-.289-1.011 2.06 2.06 0 0 1 .824-1.653 3.22 3.22 0 0 1 2.106-.674 3.3 3.3 0 0 1 2.186.7 2.21 2.21 0 0 1 .835 1.774h-1.358a1.22 1.22 0 0 0-.472-.959 1.77 1.77 0 0 0-1.19-.4 1.85 1.85 0 0 0-1.157.322 1.01 1.01 0 0 0-.417.842.82.82 0 0 0 .388.74 4.8 4.8 0 0 0 1.4.476 7.3 7.3 0 0 1 1.644.542 2.4 2.4 0 0 1 .934.758 1.86 1.86 0 0 1 .3 1.08 2.03 2.03 0 0 1-.85 1.7 3.56 3.56 0 0 1-2.2.641 4 4 0 0 1-1.684-.332 2.74 2.74 0 0 1-1.146-.941 2.27 2.27 0 0 1-.414-1.307h1.355a1.4 1.4 0 0 0 .546 1.08 2.12 2.12 0 0 0 1.344.4 2.2 2.2 0 0 0 1.234-.311.96.96 0 0 0 .465-.831m4.958-7.742v1.919h1.48v1.047h-1.479v4.915a1.1 1.1 0 0 0 .2.714.83.83 0 0 0 .674.238 3.3 3.3 0 0 0 .645-.091v1.1a4 4 0 0 1-1.04.146 1.69 1.69 0 0 1-1.373-.546 2.36 2.36 0 0 1-.461-1.56v-4.917h-1.443v-1.048h1.443v-1.919Zm6.892 3.135a4 4 0 0 0-.667-.051 1.79 1.79 0 0 0-1.805 1.133v5.625h-1.358v-7.925h1.318l.022.916a2.11 2.11 0 0 1 1.89-1.062 1.4 1.4 0 0 1 .6.1Zm2.718 6.707h-1.355v-7.925h1.355Zm-1.465-10.027a.8.8 0 0 1 .2-.557.76.76 0 0 1 .6-.227.77.77 0 0 1 .6.227.8.8 0 0 1 .205.557.77.77 0 0 1-.205.549.78.78 0 0 1-.6.22.77.77 0 0 1-.6-.22.78.78 0 0 1-.2-.549m6.812 9.068a1.95 1.95 0 0 0 1.263-.441 1.55 1.55 0 0 0 .6-1.1h1.282a2.46 2.46 0 0 1-.469 1.3 3.1 3.1 0 0 1-1.154.981 3.3 3.3 0 0 1-1.527.366 3.27 3.27 0 0 1-2.574-1.08 4.3 4.3 0 0 1-.956-2.955v-.227a4.8 4.8 0 0 1 .425-2.058 3.24 3.24 0 0 1 1.219-1.4 3.46 3.46 0 0 1 1.879-.5 3.18 3.18 0 0 1 2.216.8 2.85 2.85 0 0 1 .945 2.073h-1.286a1.87 1.87 0 0 0-.582-1.263 1.8 1.8 0 0 0-1.293-.494 1.9 1.9 0 0 0-1.6.743 3.5 3.5 0 0 0-.568 2.15v.256a3.42 3.42 0 0 0 .568 2.108 1.9 1.9 0 0 0 1.612.741m6.511-8.884v1.919h1.479v1.047h-1.479v4.915a1.1 1.1 0 0 0 .2.714.83.83 0 0 0 .674.238 3.3 3.3 0 0 0 .645-.088v1.098a4 4 0 0 1-1.04.146 1.69 1.69 0 0 1-1.373-.546 2.36 2.36 0 0 1-.461-1.56v-4.917h-1.443v-1.048h1.443v-1.919Zm6.445 5.815a4.64 4.64 0 0 1 .864-2.933 2.73 2.73 0 0 1 2.263-1.11 2.75 2.75 0 0 1 2.2.952v-4.131h1.36v11.25h-1.245l-.066-.85a2.76 2.76 0 0 1-2.263 1 2.7 2.7 0 0 1-2.245-1.131 4.7 4.7 0 0 1-.868-2.944Zm1.355.154a3.5 3.5 0 0 0 .552 2.109 1.8 1.8 0 0 0 1.543.765 1.98 1.98 0 0 0 1.882-1.157v-3.643a1.99 1.99 0 0 0-1.868-1.121 1.81 1.81 0 0 0-1.553.769 3.87 3.87 0 0 0-.556 2.277Zm12.327 3.09a2.88 2.88 0 0 1-2.322.93 2.46 2.46 0 0 1-1.93-.736 3.2 3.2 0 0 1-.67-2.179v-5.156h1.355v5.12q0 1.8 1.465 1.8a2.03 2.03 0 0 0 2.065-1.157v-5.763h1.355v7.925h-1.293Zm10.071-3.091a4.75 4.75 0 0 1-.828 2.915 2.65 2.65 0 0 1-2.241 1.106 2.9 2.9 0 0 1-2.271-.916v3.817h-1.355v-10.972h1.238l.066.879a2.79 2.79 0 0 1 2.3-1.025 2.7 2.7 0 0 1 2.26 1.077 4.8 4.8 0 0 1 .831 3Zm-1.355-.154a3.5 3.5 0 0 0-.571-2.117 1.84 1.84 0 0 0-1.567-.776 1.99 1.99 0 0 0-1.847 1.092v3.787a2 2 0 0 0 1.86 1.084 1.83 1.83 0 0 0 1.549-.773 3.82 3.82 0 0 0 .576-2.296Zm4.548 4.029h-1.355v-11.25h1.355Zm3.64 0h-1.355v-7.925h1.355Zm-1.465-10.027a.8.8 0 0 1 .2-.557.76.76 0 0 1 .6-.227.77.77 0 0 1 .6.227.8.8 0 0 1 .205.557.77.77 0 0 1-.205.549.78.78 0 0 1-.6.22.77.77 0 0 1-.6-.22.78.78 0 0 1-.2-.549m6.812 9.068a1.95 1.95 0 0 0 1.267-.441 1.55 1.55 0 0 0 .6-1.1h1.282a2.46 2.46 0 0 1-.469 1.3 3.1 3.1 0 0 1-1.154.981 3.3 3.3 0 0 1-1.527.366 3.27 3.27 0 0 1-2.574-1.08 4.3 4.3 0 0 1-.951-2.956v-.227a4.8 4.8 0 0 1 .425-2.058 3.24 3.24 0 0 1 1.219-1.4 3.46 3.46 0 0 1 1.879-.5 3.18 3.18 0 0 1 2.216.8 2.85 2.85 0 0 1 .936 2.074h-1.281a1.87 1.87 0 0 0-.582-1.263 1.8 1.8 0 0 0-1.293-.494 1.9 1.9 0 0 0-1.6.743 3.5 3.5 0 0 0-.568 2.15v.256a3.42 3.42 0 0 0 .564 2.108 1.9 1.9 0 0 0 1.611.741m9.565.959a2.9 2.9 0 0 1-.191-.835 3.02 3.02 0 0 1-2.256.981 2.8 2.8 0 0 1-1.923-.663 2.15 2.15 0 0 1-.749-1.683 2.24 2.24 0 0 1 .941-1.923 4.44 4.44 0 0 1 2.648-.677h1.318v-.623a1.52 1.52 0 0 0-.425-1.132 1.7 1.7 0 0 0-1.254-.425 1.98 1.98 0 0 0-1.216.366 1.08 1.08 0 0 0-.491.886h-1.36a1.87 1.87 0 0 1 .421-1.146 2.9 2.9 0 0 1 1.146-.875 3.84 3.84 0 0 1 1.586-.322 3.13 3.13 0 0 1 2.146.685 2.47 2.47 0 0 1 .806 1.886v3.647a4.5 4.5 0 0 0 .278 1.736v.117Zm-2.248-1.033a2.4 2.4 0 0 0 1.208-.33 2 2 0 0 0 .828-.857v-1.625h-1.062q-2.49 0-2.49 1.458a1.23 1.23 0 0 0 .425 1 1.63 1.63 0 0 0 1.091.354m7.357-8.811v1.919h1.479v1.047h-1.479v4.915a1.1 1.1 0 0 0 .2.714.83.83 0 0 0 .674.238 3.3 3.3 0 0 0 .645-.088v1.099a4 4 0 0 1-1.04.146 1.69 1.69 0 0 1-1.379-.546 2.36 2.36 0 0 1-.461-1.56v-4.917h-1.439v-1.048h1.443v-1.919Zm6.35 9.99a3.46 3.46 0 0 1-2.622-1.058 3.93 3.93 0 0 1-1.011-2.831v-.249a4.76 4.76 0 0 1 .45-2.106 3.5 3.5 0 0 1 1.26-1.45 3.17 3.17 0 0 1 1.754-.524 2.97 2.97 0 0 1 2.4 1.018 4.4 4.4 0 0 1 .857 2.915v.564h-5.369a2.82 2.82 0 0 0 .685 1.893 2.15 2.15 0 0 0 1.666.721 2.36 2.36 0 0 0 1.216-.293 3.1 3.1 0 0 0 .872-.776l.828.645a3.33 3.33 0 0 1-2.99 1.531Zm-.168-7.1a1.8 1.8 0 0 0-1.377.6 2.9 2.9 0 0 0-.688 1.674h3.97v-.1a2.58 2.58 0 0 0-.557-1.6 1.7 1.7 0 0 0-1.352-.578Zm10.257 6.954h-1.406v-10.664h1.406Zm3.977-4.175v4.175h-1.406v-10.664h3.933a3.95 3.95 0 0 1 2.743.894 3.03 3.03 0 0 1 .992 2.366 2.99 2.99 0 0 1-.97 2.391 4.13 4.13 0 0 1-2.78.839Zm0-1.15h2.527a2.53 2.53 0 0 0 1.729-.531 1.94 1.94 0 0 0 .6-1.534 2 2 0 0 0-.6-1.523 2.37 2.37 0 0 0-1.648-.593h-2.607Zm13.147 2.325a4.4 4.4 0 0 1 .2-1.377 3.5 3.5 0 0 1 .747-1.121l.959-.989a2.22 2.22 0 0 0 .615-1.494 1.7 1.7 0 0 0-.4-1.2 1.52 1.52 0 0 0-1.172-.436 1.76 1.76 0 0 0-1.2.4 1.34 1.34 0 0 0-.454 1.062h-1.358a2.47 2.47 0 0 1 .846-1.915 3.16 3.16 0 0 1 2.164-.729 2.98 2.98 0 0 1 2.157.743 2.7 2.7 0 0 1 .773 2.04 3.7 3.7 0 0 1-1.189 2.516l-.8.791a2.47 2.47 0 0 0-.533 1.709Zm-.063 2.319a.8.8 0 0 1 .2-.553.76.76 0 0 1 .6-.223.78.78 0 0 1 .6.223.79.79 0 0 1 .205.553.76.76 0 0 1-.205.546.79.79 0 0 1-.6.216.78.78 0 0 1-.6-.216.77.77 0 0 1-.2-.546"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05b5b",
    fillRule: "evenodd",
    d: "M792.561 294.294a6.456 6.456 0 1 1 6.456-6.456 6.464 6.464 0 0 1-6.456 6.456m7.731-8.047a7.89 7.89 0 0 0-7.728-6.3h-12.915a7.892 7.892 0 0 0 0 15.783h12.919a7.9 7.9 0 0 0 7.728-9.482"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(617.002 415.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 25.519,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 24.519,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 2.5
  }))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    fill: "#8d8d8d",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 7,
    fontWeight: 500,
    transform: "translate(623 419)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7
  }, "Note : "), /*#__PURE__*/React.createElement("tspan", {
    y: 7,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "Network Activity Tracking: By restricting IP address reuse for a day, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "network administrators can accurately monitor & analyze network traffic."))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M635.435 401.071h-1.67v2.876h-.943v-7.109h2.354a2.8 2.8 0 0 1 1.848.547 1.97 1.97 0 0 1 .647 1.592 1.9 1.9 0 0 1-.359 1.157 2.14 2.14 0 0 1-1 .737l1.671 3.017v.059h-1.005Zm-1.67-.767h1.437a1.63 1.63 0 0 0 1.114-.357 1.22 1.22 0 0 0 .413-.967 1.29 1.29 0 0 0-.393-1.011 1.67 1.67 0 0 0-1.134-.36h-1.437Zm7.27 3.743a2.3 2.3 0 0 1-1.748-.708 2.62 2.62 0 0 1-.674-1.892v-.166a3.2 3.2 0 0 1 .3-1.4 2.34 2.34 0 0 1 .84-.967 2.1 2.1 0 0 1 1.169-.349 1.98 1.98 0 0 1 1.6.679 2.94 2.94 0 0 1 .571 1.943v.376h-3.576a1.88 1.88 0 0 0 .457 1.262 1.44 1.44 0 0 0 1.11.482 1.6 1.6 0 0 0 .811-.2 2 2 0 0 0 .581-.518l.552.43a2.22 2.22 0 0 1-1.993 1.028m-.112-4.739a1.2 1.2 0 0 0-.918.4 1.93 1.93 0 0 0-.459 1.116h2.646v-.068a1.72 1.72 0 0 0-.371-1.069 1.13 1.13 0 0 0-.898-.379m6.294 3.239a.67.67 0 0 0-.276-.569 2.7 2.7 0 0 0-.962-.349 4.6 4.6 0 0 1-1.089-.352 1.55 1.55 0 0 1-.6-.488 1.17 1.17 0 0 1-.193-.674 1.37 1.37 0 0 1 .549-1.1 2.15 2.15 0 0 1 1.4-.449 2.2 2.2 0 0 1 1.458.464 1.47 1.47 0 0 1 .559 1.187h-.908a.82.82 0 0 0-.315-.64 1.18 1.18 0 0 0-.793-.269 1.24 1.24 0 0 0-.771.215.68.68 0 0 0-.274.562.55.55 0 0 0 .259.493 3.2 3.2 0 0 0 .935.317 5 5 0 0 1 1.1.361 1.6 1.6 0 0 1 .623.505 1.24 1.24 0 0 1 .2.72 1.35 1.35 0 0 1-.565 1.136 2.38 2.38 0 0 1-1.47.43 2.7 2.7 0 0 1-1.123-.225 1.83 1.83 0 0 1-.764-.627 1.5 1.5 0 0 1-.276-.872h.9a.94.94 0 0 0 .364.72 1.4 1.4 0 0 0 .9.266 1.46 1.46 0 0 0 .817-.209.64.64 0 0 0 .315-.553m3.306-5.161v1.279h.986v.7h-.986v3.276a.73.73 0 0 0 .132.476.56.56 0 0 0 .449.159 2.2 2.2 0 0 0 .43-.059v.73a2.6 2.6 0 0 1-.693.1 1.13 1.13 0 0 1-.913-.366 1.57 1.57 0 0 1-.308-1.04v-3.279h-.962v-.7h.962v-1.277Zm4.595 2.09a3 3 0 0 0-.444-.034 1.19 1.19 0 0 0-1.206.757v3.748h-.9v-5.283h.879l.015.61a1.41 1.41 0 0 1 1.26-.708.9.9 0 0 1 .4.068Zm1.811 4.471h-.9v-5.283h.9Zm-.977-6.685a.54.54 0 0 1 .134-.371.5.5 0 0 1 .4-.151.51.51 0 0 1 .4.151.53.53 0 0 1 .137.371.52.52 0 0 1-.137.366.52.52 0 0 1-.4.146.51.51 0 0 1-.4-.146.52.52 0 0 1-.134-.366m4.541 6.045a1.3 1.3 0 0 0 .845-.293 1.03 1.03 0 0 0 .4-.732h.854a1.64 1.64 0 0 1-.312.864 2.06 2.06 0 0 1-.769.654 2.2 2.2 0 0 1-1.018.247 2.18 2.18 0 0 1-1.716-.72 2.87 2.87 0 0 1-.637-1.97v-.151a3.2 3.2 0 0 1 .283-1.372 2.16 2.16 0 0 1 .813-.933 2.3 2.3 0 0 1 1.252-.332 2.12 2.12 0 0 1 1.477.532 1.9 1.9 0 0 1 .627 1.382h-.854a1.25 1.25 0 0 0-.388-.842 1.2 1.2 0 0 0-.862-.33 1.26 1.26 0 0 0-1.067.5 2.33 2.33 0 0 0-.378 1.433v.171a2.28 2.28 0 0 0 .376 1.406 1.27 1.27 0 0 0 1.074.486m4.341-5.923v1.279h.986v.7h-.986v3.276a.73.73 0 0 0 .132.476.56.56 0 0 0 .449.159 2.2 2.2 0 0 0 .43-.059v.732a2.6 2.6 0 0 1-.693.1 1.13 1.13 0 0 1-.913-.366 1.57 1.57 0 0 1-.308-1.04v-3.279h-.962v-.7h.962v-1.277Zm4.3 3.877a3.1 3.1 0 0 1 .576-1.956 1.82 1.82 0 0 1 1.509-.74 1.83 1.83 0 0 1 1.47.635v-2.753h.9v7.5h-.83l-.044-.566a1.84 1.84 0 0 1-1.513.666 1.8 1.8 0 0 1-1.5-.752 3.13 3.13 0 0 1-.579-1.963Zm.9.1a2.34 2.34 0 0 0 .368 1.409 1.2 1.2 0 0 0 1.025.508 1.32 1.32 0 0 0 1.255-.771v-2.427a1.33 1.33 0 0 0-1.245-.747 1.2 1.2 0 0 0-1.035.514 2.6 2.6 0 0 0-.368 1.517Zm8.218 2.064a1.92 1.92 0 0 1-1.55.622 1.64 1.64 0 0 1-1.287-.491 2.12 2.12 0 0 1-.447-1.453v-3.439h.9v3.413q0 1.2.977 1.2a1.35 1.35 0 0 0 1.377-.771v-3.842h.9v5.283h-.85Zm6.714-2.061a3.16 3.16 0 0 1-.552 1.943 1.77 1.77 0 0 1-1.494.74 1.94 1.94 0 0 1-1.518-.613v2.544h-.9v-7.314h.825l.044.586a1.86 1.86 0 0 1 1.531-.684 1.8 1.8 0 0 1 1.506.718 3.2 3.2 0 0 1 .554 2Zm-.9-.1a2.33 2.33 0 0 0-.384-1.417 1.23 1.23 0 0 0-1.045-.518 1.33 1.33 0 0 0-1.23.728v2.524a1.33 1.33 0 0 0 1.24.723 1.22 1.22 0 0 0 1.033-.515 2.55 2.55 0 0 0 .383-1.528Zm3.029 2.683h-.9v-7.5h.9Zm2.427 0h-.9v-5.283h.9Zm-.977-6.685a.54.54 0 0 1 .134-.371.5.5 0 0 1 .4-.151.51.51 0 0 1 .4.151.53.53 0 0 1 .137.371.52.52 0 0 1-.137.366.52.52 0 0 1-.4.146.51.51 0 0 1-.4-.146.52.52 0 0 1-.134-.366m4.541 6.045a1.3 1.3 0 0 0 .845-.293 1.03 1.03 0 0 0 .4-.732h.854a1.64 1.64 0 0 1-.312.864 2.06 2.06 0 0 1-.769.654 2.2 2.2 0 0 1-1.018.247 2.18 2.18 0 0 1-1.716-.72 2.87 2.87 0 0 1-.637-1.97v-.151a3.2 3.2 0 0 1 .283-1.372 2.16 2.16 0 0 1 .813-.933 2.3 2.3 0 0 1 1.252-.332 2.12 2.12 0 0 1 1.477.532 1.9 1.9 0 0 1 .627 1.382h-.854a1.25 1.25 0 0 0-.388-.842 1.2 1.2 0 0 0-.862-.33 1.26 1.26 0 0 0-1.067.5 2.33 2.33 0 0 0-.378 1.433v.171a2.28 2.28 0 0 0 .376 1.406 1.27 1.27 0 0 0 1.074.486m6.377.64a1.9 1.9 0 0 1-.127-.557 2.02 2.02 0 0 1-1.504.657 1.87 1.87 0 0 1-1.282-.442 1.43 1.43 0 0 1-.5-1.121 1.5 1.5 0 0 1 .627-1.282 2.96 2.96 0 0 1 1.765-.455h.879v-.415a1.01 1.01 0 0 0-.283-.754 1.14 1.14 0 0 0-.835-.281 1.3 1.3 0 0 0-.811.244.72.72 0 0 0-.327.591h-.908a1.25 1.25 0 0 1 .281-.764 1.9 1.9 0 0 1 .762-.583 2.6 2.6 0 0 1 1.057-.215 2.1 2.1 0 0 1 1.431.457 1.65 1.65 0 0 1 .537 1.257v2.432a3 3 0 0 0 .186 1.157v.074Zm-1.5-.688a1.6 1.6 0 0 0 .806-.22 1.33 1.33 0 0 0 .552-.571v-1.084h-.708q-1.66 0-1.66.972a.82.82 0 0 0 .283.664 1.1 1.1 0 0 0 .728.239Zm4.9-5.874v1.279h.986v.7h-.986v3.276a.73.73 0 0 0 .139.474.56.56 0 0 0 .449.159 2.2 2.2 0 0 0 .43-.059v.733a2.6 2.6 0 0 1-.693.1 1.13 1.13 0 0 1-.913-.366 1.57 1.57 0 0 1-.308-1.04v-3.279h-.965v-.7h.962v-1.277Zm4.239 6.662a2.3 2.3 0 0 1-1.75-.708 2.62 2.62 0 0 1-.674-1.892v-.166a3.2 3.2 0 0 1 .3-1.4 2.34 2.34 0 0 1 .84-.967 2.1 2.1 0 0 1 1.169-.349 1.98 1.98 0 0 1 1.6.679 2.94 2.94 0 0 1 .571 1.943v.376h-3.577a1.88 1.88 0 0 0 .457 1.262 1.44 1.44 0 0 0 1.111.481 1.6 1.6 0 0 0 .811-.2 2 2 0 0 0 .581-.518l.552.43a2.22 2.22 0 0 1-1.991 1.029m-.112-4.736a1.2 1.2 0 0 0-.918.4 1.93 1.93 0 0 0-.459 1.116h2.646v-.068a1.72 1.72 0 0 0-.371-1.067 1.13 1.13 0 0 0-.901-.384Zm6.838 4.636h-.937v-7.109h.938Zm2.651-2.783v2.783h-.937v-7.109h2.622a2.63 2.63 0 0 1 1.829.6 2.02 2.02 0 0 1 .662 1.577 2 2 0 0 1-.647 1.594 2.75 2.75 0 0 1-1.853.559Zm0-.767h1.685a1.7 1.7 0 0 0 1.152-.35 1.3 1.3 0 0 0 .4-1.023 1.34 1.34 0 0 0-.4-1.016 1.58 1.58 0 0 0-1.1-.4h-1.736Zm7.466.859a3.1 3.1 0 0 1 .305-1.4 2.3 2.3 0 0 1 .85-.957 2.3 2.3 0 0 1 1.243-.337 2.23 2.23 0 0 1 1.746.747 2.87 2.87 0 0 1 .667 1.987v.063a3.15 3.15 0 0 1-.3 1.384 2.24 2.24 0 0 1-.845.955 2.34 2.34 0 0 1-1.258.349 2.22 2.22 0 0 1-1.741-.749 2.86 2.86 0 0 1-.667-1.978Zm.908.107a2.26 2.26 0 0 0 .408 1.411 1.3 1.3 0 0 0 1.091.532 1.3 1.3 0 0 0 1.094-.54 2.47 2.47 0 0 0 .406-1.509 2.26 2.26 0 0 0-.413-1.41 1.31 1.31 0 0 0-1.1-.54 1.3 1.3 0 0 0-1.079.532 2.45 2.45 0 0 0-.406 1.525Zm7.149 1.944a1.3 1.3 0 0 0 .845-.293 1.03 1.03 0 0 0 .4-.732h.854a1.64 1.64 0 0 1-.312.864 2.06 2.06 0 0 1-.769.654 2.2 2.2 0 0 1-1.018.247 2.18 2.18 0 0 1-1.716-.72 2.87 2.87 0 0 1-.637-1.97v-.151a3.2 3.2 0 0 1 .283-1.372 2.16 2.16 0 0 1 .813-.933 2.3 2.3 0 0 1 1.257-.335 2.12 2.12 0 0 1 1.477.532 1.9 1.9 0 0 1 .627 1.382h-.854a1.25 1.25 0 0 0-.388-.842 1.2 1.2 0 0 0-.862-.33 1.26 1.26 0 0 0-1.067.5 2.33 2.33 0 0 0-.378 1.433v.171a2.28 2.28 0 0 0 .376 1.406 1.27 1.27 0 0 0 1.069.489m5.234 0a1.3 1.3 0 0 0 .845-.293 1.03 1.03 0 0 0 .4-.732h.854a1.64 1.64 0 0 1-.312.864 2.06 2.06 0 0 1-.769.654 2.2 2.2 0 0 1-1.013.247 2.18 2.18 0 0 1-1.716-.72 2.87 2.87 0 0 1-.637-1.97v-.151a3.2 3.2 0 0 1 .283-1.372 2.16 2.16 0 0 1 .813-.933 2.3 2.3 0 0 1 1.252-.332 2.12 2.12 0 0 1 1.477.532 1.9 1.9 0 0 1 .627 1.382h-.854a1.25 1.25 0 0 0-.388-.842 1.2 1.2 0 0 0-.862-.33 1.26 1.26 0 0 0-1.067.5 2.33 2.33 0 0 0-.378 1.433v.171a2.28 2.28 0 0 0 .376 1.406 1.27 1.27 0 0 0 1.074.486Zm6.377.117a1.92 1.92 0 0 1-1.548.62 1.64 1.64 0 0 1-1.287-.491 2.12 2.12 0 0 1-.447-1.453v-3.436h.9v3.413q0 1.2.977 1.2a1.35 1.35 0 0 0 1.377-.771v-3.842h.9v5.283h-.859Zm4.8-3.95a3 3 0 0 0-.444-.034 1.19 1.19 0 0 0-1.206.757v3.75h-.9v-5.283h.879l.015.61a1.41 1.41 0 0 1 1.26-.708.9.9 0 0 1 .4.068Zm3.384 0a3 3 0 0 0-.444-.034 1.19 1.19 0 0 0-1.206.757v3.75h-.9v-5.283h.879l.015.61a1.41 1.41 0 0 1 1.26-.708.9.9 0 0 1 .4.068Zm3.032 4.573a2.3 2.3 0 0 1-1.748-.706 2.62 2.62 0 0 1-.674-1.887v-.166a3.2 3.2 0 0 1 .3-1.4 2.34 2.34 0 0 1 .84-.967 2.1 2.1 0 0 1 1.169-.349 1.98 1.98 0 0 1 1.6.679 2.94 2.94 0 0 1 .571 1.943v.376h-3.579a1.88 1.88 0 0 0 .457 1.262 1.44 1.44 0 0 0 1.111.481 1.6 1.6 0 0 0 .811-.2 2 2 0 0 0 .581-.518l.552.43a2.22 2.22 0 0 1-1.991 1.022m-.112-4.736a1.2 1.2 0 0 0-.918.4 1.93 1.93 0 0 0-.459 1.116h2.646v-.068a1.72 1.72 0 0 0-.371-1.067 1.13 1.13 0 0 0-.898-.384Zm4.072-.645.029.664a1.93 1.93 0 0 1 1.582-.762q1.675 0 1.689 1.89v3.489h-.9v-3.5a1.22 1.22 0 0 0-.261-.845 1.05 1.05 0 0 0-.8-.273 1.3 1.3 0 0 0-.771.234 1.6 1.6 0 0 0-.518.615v3.769h-.9v-5.283Zm6.782 4.641a1.3 1.3 0 0 0 .845-.293 1.03 1.03 0 0 0 .4-.732h.854a1.64 1.64 0 0 1-.312.864 2.06 2.06 0 0 1-.769.654 2.2 2.2 0 0 1-1.018.247 2.18 2.18 0 0 1-1.716-.72 2.87 2.87 0 0 1-.637-1.97v-.151a3.2 3.2 0 0 1 .283-1.372 2.16 2.16 0 0 1 .813-.933 2.3 2.3 0 0 1 1.252-.332 2.12 2.12 0 0 1 1.477.532 1.9 1.9 0 0 1 .627 1.382h-.854a1.25 1.25 0 0 0-.388-.842 1.2 1.2 0 0 0-.862-.33 1.26 1.26 0 0 0-1.067.5 2.33 2.33 0 0 0-.378 1.433v.171a2.28 2.28 0 0 0 .376 1.406 1.27 1.27 0 0 0 1.074.486m5.308.74a2.3 2.3 0 0 1-1.748-.706 2.62 2.62 0 0 1-.674-1.887v-.166a3.2 3.2 0 0 1 .3-1.4 2.34 2.34 0 0 1 .84-.967 2.1 2.1 0 0 1 1.169-.349 1.98 1.98 0 0 1 1.6.679 2.94 2.94 0 0 1 .571 1.943v.376h-3.579a1.88 1.88 0 0 0 .457 1.262 1.44 1.44 0 0 0 1.111.481 1.6 1.6 0 0 0 .811-.2 2 2 0 0 0 .581-.518l.552.43a2.22 2.22 0 0 1-1.991 1.022m-.112-4.736a1.2 1.2 0 0 0-.918.4 1.93 1.93 0 0 0-.459 1.116h2.646v-.068a1.72 1.72 0 0 0-.371-1.067 1.13 1.13 0 0 0-.898-.384Zm10.371 3.394 1.016-4.038h.9l-1.535 5.28h-.732l-1.285-4-1.25 4h-.732l-1.533-5.283h.9l1.04 3.955 1.23-3.955h.728Zm3.818 1.242h-.9v-5.283h.9Zm-.977-6.685a.54.54 0 0 1 .134-.371.5.5 0 0 1 .4-.151.51.51 0 0 1 .4.151.53.53 0 0 1 .137.371.52.52 0 0 1-.137.366.52.52 0 0 1-.4.146.51.51 0 0 1-.4-.146.52.52 0 0 1-.133-.366Zm3.647.122v1.279h.986v.7h-.986v3.276a.73.73 0 0 0 .132.476.56.56 0 0 0 .449.159 2.2 2.2 0 0 0 .43-.059v.732a2.6 2.6 0 0 1-.693.1 1.13 1.13 0 0 1-.913-.366 1.57 1.57 0 0 1-.308-1.04v-3.279h-.962v-.7h.962v-1.277Zm2.944 1.919a1.92 1.92 0 0 1 1.563-.737q1.675 0 1.689 1.89v3.491h-.9v-3.5a1.22 1.22 0 0 0-.261-.845 1.05 1.05 0 0 0-.8-.273 1.3 1.3 0 0 0-.771.234 1.6 1.6 0 0 0-.518.615v3.769h-.9v-7.5h.9Zm5.587 4.644h-.9v-5.283h.9Zm-.977-6.685a.54.54 0 0 1 .134-.371.5.5 0 0 1 .4-.151.51.51 0 0 1 .4.151.53.53 0 0 1 .137.371.52.52 0 0 1-.137.366.52.52 0 0 1-.4.146.51.51 0 0 1-.4-.146.52.52 0 0 1-.133-.366Zm3.276 1.4.029.664a1.93 1.93 0 0 1 1.582-.762q1.675 0 1.689 1.89v3.493h-.9v-3.5a1.22 1.22 0 0 0-.261-.845 1.05 1.05 0 0 0-.8-.273 1.3 1.3 0 0 0-.771.234 1.6 1.6 0 0 0-.518.615v3.769h-.9v-5.283Zm46.528 2.6a3.1 3.1 0 0 1 .576-1.956 1.82 1.82 0 0 1 1.509-.74 1.83 1.83 0 0 1 1.47.635v-2.754h.9v7.5h-.83l-.044-.566a1.84 1.84 0 0 1-1.504.666 1.8 1.8 0 0 1-1.5-.752 3.13 3.13 0 0 1-.579-1.963Zm.9.1a2.34 2.34 0 0 0 .371 1.406 1.2 1.2 0 0 0 1.025.508 1.32 1.32 0 0 0 1.255-.771v-2.425a1.33 1.33 0 0 0-1.245-.747 1.2 1.2 0 0 0-1.035.513 2.6 2.6 0 0 0-.366 1.518Zm8.218 2.585a1.9 1.9 0 0 1-.127-.557 2.02 2.02 0 0 1-1.5.654 1.87 1.87 0 0 1-1.282-.442 1.43 1.43 0 0 1-.5-1.121 1.5 1.5 0 0 1 .627-1.282 2.96 2.96 0 0 1 1.765-.457h.879v-.415a1.01 1.01 0 0 0-.283-.754 1.14 1.14 0 0 0-.835-.281 1.3 1.3 0 0 0-.811.244.72.72 0 0 0-.327.591h-.906a1.25 1.25 0 0 1 .281-.764 1.9 1.9 0 0 1 .762-.583 2.6 2.6 0 0 1 1.057-.215 2.1 2.1 0 0 1 1.431.457 1.65 1.65 0 0 1 .537 1.257v2.432a3 3 0 0 0 .186 1.157v.079Zm-1.5-.688a1.6 1.6 0 0 0 .806-.22 1.33 1.33 0 0 0 .552-.571v-1.084h-.708q-1.66 0-1.66.972a.82.82 0 0 0 .283.664 1.1 1.1 0 0 0 .732.239Zm5.405-.635 1.23-3.96h.967l-2.124 6.1q-.493 1.318-1.567 1.318l-.171-.015-.337-.063v-.734l.244.02a1.2 1.2 0 0 0 .715-.186 1.34 1.34 0 0 0 .422-.679l.2-.537-1.885-5.225h.986Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M622.162 396.187a4 4 0 1 1-4 4 4.014 4.014 0 0 1 4-4m0-.709a4.712 4.712 0 1 0 4.718 4.712 4.707 4.707 0 0 0-4.718-4.712"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#cfcfcf",
    transform: "translate(805.002 391.947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 20,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 19,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 2.5
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M750.124 383.215a4.7 4.7 0 0 1-.408 2.025 3.07 3.07 0 0 1-1.168 1.343 3.23 3.23 0 0 1-1.746.472 3.25 3.25 0 0 1-1.732-.467 3.1 3.1 0 0 1-1.182-1.335 4.6 4.6 0 0 1-.424-2v-.387a4.7 4.7 0 0 1 .416-2.028 3.1 3.1 0 0 1 1.176-1.348 3.24 3.24 0 0 1 1.738-.47 3.24 3.24 0 0 1 1.738.47 3.1 3.1 0 0 1 1.176 1.348 4.7 4.7 0 0 1 .416 2.028Zm-1.633-.354a3.3 3.3 0 0 0-.44-1.869 1.44 1.44 0 0 0-1.257-.644 1.44 1.44 0 0 0-1.251.631 3.25 3.25 0 0 0-.446 1.85v.381a3.33 3.33 0 0 0 .44 1.858 1.43 1.43 0 0 0 1.265.666 1.42 1.42 0 0 0 1.249-.636 3.3 3.3 0 0 0 .44-1.856Zm5.7 1.225h-1.289v2.862h-1.607v-7.82h2.907a3.3 3.3 0 0 1 2.138.618 2.13 2.13 0 0 1 .752 1.746 2.4 2.4 0 0 1-.346 1.335 2.36 2.36 0 0 1-1.05.851l1.692 3.2v.07h-1.732Zm-1.289-1.306h1.3a1.33 1.33 0 0 0 .94-.309 1.1 1.1 0 0 0 .333-.851 1.18 1.18 0 0 0-.314-.87 1.3 1.3 0 0 0-.964-.317h-1.295Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e5e5",
    d: "M762.002 382.948h69v1h-69zM668.002 382.948h68v1h-68z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M381.12 286.729h-4.475v4.739h-1.406v-10.732h6.606v1.16h-5.2v3.671h4.475Zm3.67 4.739h-1.355v-7.972h1.355Zm-1.465-10.091a.82.82 0 0 1 .2-.56.75.75 0 0 1 .6-.229.77.77 0 0 1 .6.229.8.8 0 0 1 .205.56.78.78 0 0 1-.205.553.78.78 0 0 1-.6.221.77.77 0 0 1-.6-.221.8.8 0 0 1-.2-.553m5.105 10.091h-1.355v-11.322h1.355Zm4.006-9.907v1.935h1.479v1.054h-1.479v4.946a1.1 1.1 0 0 0 .2.719.83.83 0 0 0 .674.24 3.3 3.3 0 0 0 .645-.088v1.101a4 4 0 0 1-1.04.147 1.68 1.68 0 0 1-1.37-.553 2.4 2.4 0 0 1-.464-1.566v-4.949h-1.443v-1.051h1.443v-1.935Zm6.35 10.055a3.45 3.45 0 0 1-2.622-1.065 3.97 3.97 0 0 1-1.011-2.849v-.251a4.8 4.8 0 0 1 .45-2.119 3.53 3.53 0 0 1 1.26-1.46 3.15 3.15 0 0 1 1.754-.527 2.96 2.96 0 0 1 2.4 1.025 4.46 4.46 0 0 1 .857 2.934v.568h-5.366a2.85 2.85 0 0 0 .685 1.905 2.15 2.15 0 0 0 1.666.726 2.35 2.35 0 0 0 1.216-.295 3.1 3.1 0 0 0 .872-.781l.828.649a3.32 3.32 0 0 1-2.989 1.54m-.168-7.15a1.8 1.8 0 0 0-1.377.6 2.93 2.93 0 0 0-.688 1.684h3.97v-.1a2.6 2.6 0 0 0-.557-1.611 1.7 1.7 0 0 0-1.348-.573m8.657.251a4 4 0 0 0-.667-.052 1.785 1.785 0 0 0-1.807 1.142v5.661h-1.357v-7.972h1.318l.022.921a2.11 2.11 0 0 1 1.89-1.069 1.4 1.4 0 0 1 .6.1Zm11.667 2.852a4.76 4.76 0 0 1-.835 2.937 2.66 2.66 0 0 1-2.241 1.11 2.76 2.76 0 0 1-2.322-1.069l-.066.921h-1.245v-11.322h1.355v4.224a2.74 2.74 0 0 1 2.263-1.025 2.68 2.68 0 0 1 2.267 1.1 4.9 4.9 0 0 1 .824 3.007Zm-1.355-.155a3.7 3.7 0 0 0-.535-2.152 1.77 1.77 0 0 0-1.538-.759 1.99 1.99 0 0 0-1.926 1.253v3.45a2.04 2.04 0 0 0 1.941 1.252 1.76 1.76 0 0 0 1.516-.762 3.94 3.94 0 0 0 .542-2.282m5.654 2.057 1.846-5.975h1.45l-3.185 9.2q-.74 1.99-2.351 1.99l-.256-.022-.505-.1v-1.098l.361.03a1.8 1.8 0 0 0 1.073-.28 2.03 2.03 0 0 0 .638-1.025l.3-.811-2.827-7.884h1.479Zm11.4 1.032a1.94 1.94 0 0 0 1.26-.443 1.56 1.56 0 0 0 .6-1.106h1.282a2.5 2.5 0 0 1-.469 1.3 3.1 3.1 0 0 1-1.154.988 3.3 3.3 0 0 1-1.522.374 3.26 3.26 0 0 1-2.574-1.088 4.35 4.35 0 0 1-.956-2.974v-.228a4.8 4.8 0 0 1 .425-2.071 3.25 3.25 0 0 1 1.219-1.409 3.45 3.45 0 0 1 1.879-.5 3.17 3.17 0 0 1 2.216.8 2.88 2.88 0 0 1 .941 2.086h-1.287a1.88 1.88 0 0 0-.582-1.272 1.8 1.8 0 0 0-1.293-.5 1.89 1.89 0 0 0-1.6.748 3.53 3.53 0 0 0-.568 2.163v.258a3.46 3.46 0 0 0 .564 2.123 1.9 1.9 0 0 0 1.616.751Zm4.314-3.1a4.7 4.7 0 0 1 .455-2.107 3.43 3.43 0 0 1 1.274-1.445 3.45 3.45 0 0 1 1.864-.509 3.33 3.33 0 0 1 2.618 1.128 4.36 4.36 0 0 1 1 3v.1a4.8 4.8 0 0 1-.443 2.09 3.4 3.4 0 0 1-1.267 1.436 3.5 3.5 0 0 1-1.893.52 3.32 3.32 0 0 1-2.611-1.128 4.33 4.33 0 0 1-1-2.985Zm1.362.162a3.43 3.43 0 0 0 .612 2.13 1.95 1.95 0 0 0 1.637.8 1.94 1.94 0 0 0 1.635-.807 3.75 3.75 0 0 0 .608-2.281 3.42 3.42 0 0 0-.619-2.127 1.96 1.96 0 0 0-1.644-.815 1.94 1.94 0 0 0-1.619.8 3.72 3.72 0 0 0-.613 2.304Zm12.441 3.115a2.87 2.87 0 0 1-2.321.936 2.46 2.46 0 0 1-1.93-.741 3.22 3.22 0 0 1-.67-2.193v-5.186h1.354v5.153q0 1.813 1.465 1.813a2.03 2.03 0 0 0 2.066-1.166v-5.8h1.355v7.972h-1.289Zm4.659-7.184.044 1a2.88 2.88 0 0 1 2.373-1.15q2.512 0 2.534 2.853v5.269h-1.355v-5.278a1.84 1.84 0 0 0-.392-1.275 1.56 1.56 0 0 0-1.2-.413 1.95 1.95 0 0 0-1.157.354 2.4 2.4 0 0 0-.776.929v5.683h-1.353v-7.972Zm8.833-1.931v1.931h1.479v1.054h-1.479v4.946a1.1 1.1 0 0 0 .2.719.83.83 0 0 0 .674.24 3.3 3.3 0 0 0 .645-.088v1.101a4 4 0 0 1-1.04.147 1.68 1.68 0 0 1-1.37-.553 2.4 2.4 0 0 1-.461-1.57v-4.945h-1.446v-1.051h1.443v-1.935Zm6.892 3.151a4 4 0 0 0-.667-.052 1.785 1.785 0 0 0-1.809 1.143v5.661h-1.355v-7.972h1.318l.022.921a2.11 2.11 0 0 1 1.89-1.069 1.4 1.4 0 0 1 .6.1Zm3.838 4.754 1.845-5.974h1.45l-3.186 9.2q-.74 1.99-2.351 1.99l-.256-.022-.505-.1v-1.098l.366.029a1.8 1.8 0 0 0 1.073-.28 2.03 2.03 0 0 0 .634-1.025l.3-.811-2.828-7.883h1.479Z"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(374.002 334.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 24.186,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 23.186,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 2.5
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    fill: "#8d8d8d",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 7,
    fontWeight: 500,
    transform: "translate(379.356 337.912)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7
  }, "Note : "), /*#__PURE__*/React.createElement("tspan", {
    y: 7,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "It's important to note that achieving perfect accuracy "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15,
    fontFamily: "Poppins-Regular, Poppins",
    fontWeight: 400
  }, "may not always be feasible or realistic in certain scenarios."))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e5e5e5",
    transform: "translate(374.002 301.666)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 226,
    height: 30,
    stroke: "none",
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 29,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 2.5
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#617482",
    d: "M592.479 315.266a.43.43 0 0 0-.549 0l-4.827 4.252-4.836-4.252a.43.43 0 0 0-.549 0 .313.313 0 0 0 0 .483l5.1 4.485a.4.4 0 0 0 .274.1.43.43 0 0 0 .274-.1l5.1-4.485a.307.307 0 0 0 .009-.483Z"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    fill: "#424242",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 11,
    transform: "translate(380.002 320.666)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search with country name "))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    fillRule: "evenodd",
    d: "M509.255 293.859a6.506 6.506 0 1 1 6.836-6.5 6.68 6.68 0 0 1-6.836 6.5m8.186-8.1a8.264 8.264 0 0 0-8.183-6.341H495.58a7.952 7.952 0 1 0 0 15.884h13.679a8.154 8.154 0 0 0 8.352-7.942 7.6 7.6 0 0 0-.17-1.6"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(843.001 448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.425,
    height: 25,
    fill: "url(#resQ_Slider4_svg__e)",
    rx: 12.5
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 8,
    fontWeight: 600,
    transform: "translate(18 15)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Update")))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "url(#resQ_Slider4_svg__f)",
    stroke: "#ddd",
    transform: "translate(777 448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.425,
    height: 25,
    stroke: "none",
    rx: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60.425,
    height: 24,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 12
  }))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-SemiBold, Poppins",
    fontSize: 8,
    fontWeight: 600,
    transform: "translate(796 463)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reset"))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M0 80h918v52H0z"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 89)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 35,
    fill: "#ea595b",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.004 7.004a11 11 0 1 0 11 11 11 11 0 0 0-11-11m-.755 14.62a.42.42 0 0 1-.418.419H15.99a.42.42 0 0 1-.418-.419V14.38a.42.42 0 0 1 .418-.418h1.837a.42.42 0 0 1 .418.418Zm4.183 0a.42.42 0 0 1-.418.419h-1.841a.42.42 0 0 1-.418-.419V14.38a.42.42 0 0 1 .418-.418h1.837a.42.42 0 0 1 .418.418Z"
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    fill: "#989898",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(175.378 121)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Filter by Device"))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M165.811 116.575a.893.893 0 0 0-.893.894v3.954h4.067v-3.953a.894.894 0 0 0-.894-.894zm1.187 5.83a.3.3 0 1 1-.3.3.3.3 0 0 1 .3-.3m-.1-10.037h-10.526a.9.9 0 0 0-.895.895v6.007h8.438a.3.3 0 1 1 0 .6h-8.438v1.042a.9.9 0 0 0 .895.9h4.189v.949h-1.189a.3.3 0 1 0 0 .6h4.524a.3.3 0 1 0 0-.6h-1.191v-.949h1.8v-4.342a1.306 1.306 0 0 1 1.266-1.306h2.021v-2.9a.9.9 0 0 0-.895-.895Zm-1.98 9.652v.438a.894.894 0 0 0 .895.894h2.278a.894.894 0 0 0 .894-.894v-.438h-4.068Z"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed5b5a",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(287.483 121)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Score"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed5b5a",
    fontFamily: "HonestJohns, Honest Johns",
    fontSize: 12,
    transform: "translate(267.582 120.471)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Q"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(378.704 121)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Restrict Duplicate IP")), /*#__PURE__*/React.createElement("path", {
    d: "M367.241 122.809h-.513c-.28.3-.538.562-.741.761a.75.75 0 0 1-.52.211.73.73 0 0 1-.52-.213c-.2-.2-.459-.455-.741-.759h-.516c-.716.128-1.179.333-1.179.564 0 .392 1.323.71 2.955.71s2.955-.317 2.955-.71c.001-.234-.462-.434-1.18-.564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.232 123.278a.336.336 0 0 0 .473 0c.757-.739 3.069-3.115 3.069-4.644a3.305 3.305 0 0 0-6.61 0c-.003 1.528 2.311 3.907 3.068 4.644m-1.539-4.788a1.775 1.775 0 1 1 1.776 1.776 1.777 1.777 0 0 1-1.776-1.776M360.822 112.283a.242.242 0 1 0 .242.242.24.24 0 0 0-.242-.242M362.502 112.283a.242.242 0 1 0 .242.242.24.24 0 0 0-.242-.242M369.827 112.362h-4.35a.163.163 0 1 0 0 .325h4.349a.163.163 0 0 0 0-.325Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.944 111.238h-8.954a1.83 1.83 0 0 0-1.829 1.829v.544h12.61v-.544a1.825 1.825 0 0 0-1.827-1.829m-9.123 1.932a.646.646 0 1 1 .645-.647.647.647 0 0 1-.645.647m1.68 0a.646.646 0 1 1 .645-.647.647.647 0 0 1-.644.647Zm7.33-.079h-4.354a.567.567 0 0 1 0-1.135h4.354a.567.567 0 0 1 0 1.135M359.161 119.029a1.83 1.83 0 0 0 1.827 1.831h1.643a4.4 4.4 0 0 1-.877-2.224 3.709 3.709 0 0 1 7.418 0 4.4 4.4 0 0 1-.877 2.224h1.648a1.83 1.83 0 0 0 1.827-1.831v-5.015h-12.609Zm10.515-4.309a.2.2 0 0 1 .2-.2h.524a.615.615 0 0 1 0 1.23h-.323v.475a.203.203 0 1 1-.406 0v-1.5Zm-.82 0a.203.203 0 1 1 .406 0v1.5a.203.203 0 1 1-.406 0Zm-8.778-.27h1.9a.203.203 0 1 1 0 .406h-1.9a.203.203 0 1 1 0-.406m0 .678h1.19a.203.203 0 0 1 0 .406h-1.19a.203.203 0 0 1 0-.406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.614 115.133a.21.21 0 0 0-.211-.211h-.323v.422h.323a.21.21 0 0 0 .211-.211"
  }))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 15,
    fontWeight: 700,
    transform: "translate(48 101)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "McDonalds Survey"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    fill: "#6c6c6c",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 15,
    transform: "translate(48 124)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ASDF1234"))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M129.474 112a6.016 6.016 0 1 0 6.016 6.016 6.017 6.017 0 0 0-6.016-6.016m-.7 8.613v-2.754a.7.7 0 0 1 1.39 0v2.754a.7.7 0 1 1-1.39 0m.7-4.208a.836.836 0 1 1 .836-.836.836.836 0 0 1-.836.836"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#e4f4e4",
    stroke: "#4baf4b",
    transform: "translate(197 91)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 14,
    stroke: "none",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 13,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 1.5
  }))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    fill: "#4baf4b",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 10,
    fontWeight: 500,
    transform: "translate(202 102)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Live"))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 13,
    fontWeight: 300,
    transform: "translate(771.55 109)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Refresh Dashboard"))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    fillRule: "evenodd",
    d: "M755.637 97.121a7.379 7.379 0 1 0 7.379 7.379 7.387 7.387 0 0 0-7.379-7.379m0 3.162a4.22 4.22 0 0 1 3.568 1.969.527.527 0 0 1-.891.563 3.163 3.163 0 0 0-5.509.28l.6-.2a.527.527 0 1 1 .333 1l-1.581.527a.53.53 0 0 1-.666-.333l-.527-1.581a.527.527 0 0 1 1-.333l.055.163a4.22 4.22 0 0 1 3.618-2.055m3.6 4.219a.526.526 0 0 1 .551.358l.527 1.581a.527.527 0 1 1-1 .333l-.046-.139a4.217 4.217 0 0 1-7.454-.347.527.527 0 1 1 .954-.448 3.164 3.164 0 0 0 5.727.005l-.624.208a.527.527 0 0 1-.333-1l1.581-.527a.5.5 0 0 1 .115-.024Z"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c",
    transform: "translate(633 99.289)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.616,
    cy: 2.616,
    r: 2.616,
    transform: "translate(4.368 3.769)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.789 1.695a.11.11 0 0 0 .092-.051L4.519.612A1.29 1.29 0 0 1 5.619 0h2.734a1.29 1.29 0 0 1 1.1.612l.638 1.032a.11.11 0 0 0 .092.051h2.107a1.68 1.68 0 0 1 1.682 1.681V9.31a1.68 1.68 0 0 1-1.682 1.682H1.682A1.68 1.68 0 0 1 0 9.31V3.376a1.68 1.68 0 0 1 1.682-1.681Zm3.2 1.158a3.532 3.532 0 1 1-3.532 3.532 3.533 3.533 0 0 1 3.528-3.531Zm4.893 0a.819.819 0 1 1-.819.819.82.82 0 0 1 .815-.818Z"
  }))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 13,
    fontWeight: 300,
    transform: "translate(655.676 109)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Screenshot"))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#989898",
    d: "M917.744 104.766a1.561 1.561 0 1 1-1.561-1.561 1.56 1.56 0 0 1 1.561 1.561m-1.562-8.091a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561m0 13.058a1.561 1.561 0 1 0 1.561 1.561 1.56 1.56 0 0 0-1.561-1.561"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(918 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -78,
    y: 0
  }, "resQ Settings"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    fill: "#848484",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(746 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard"))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    fill: "#989898",
    fontFamily: "TeluguMN-Bold, Telugu MN",
    fontSize: 15,
    fontWeight: 700,
    transform: "translate(823 158)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "/"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(0 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard "))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ed595b",
    d: "M120 163h91v1h-91z"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    fill: "#ed595b",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(120 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "resQ Settings"))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(249 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Share Project"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(378 155)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Reports & Downloads"))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M3 0h919v74H3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M3 75h919v1H3z"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#eaeaea",
    transform: "translate(665.238 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "m698.426 35.128-.361-.874c1.237-2.853 1.156-2.938.914-3.182l-1.58-1.576-.157-.136h-.182c-.1 0-.384 0-2.788 1.112l-.885-.365c-1.143-2.892-1.26-2.892-1.599-2.892h-2.226c-.335 0-.465 0-1.523 2.9l-.88.365a15 15 0 0 0-2.833-1.059h-.212l-1.695 1.694c-.261.265-.352.352.957 3.161l-.361.872c-2.896 1.145-2.896 1.255-2.896 1.614v2.223c0 .35 0 .473 2.9 1.536l.361.87c-1.237 2.853-1.154 2.938-.914 3.182l1.581 1.578.157.138h.185c.1 0 .38 0 2.786-1.114l.883.367c1.144 2.887 1.26 2.887 1.606 2.887h2.221c.342 0 .462 0 1.525-2.9l.885-.365a15 15 0 0 0 2.828 1.061h.212l1.717-1.71c.244-.25.329-.337-.972-3.136l.359-.872c2.9-1.154 2.9-1.275 2.9-1.623V36.66c-.004-.345-.004-.473-2.913-1.532m-7.7 6.4a3.713 3.713 0 1 1 3.7-3.711 3.713 3.713 0 0 1-3.7 3.711"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#dedede",
    transform: "translate(284.581 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    fillRule: "evenodd",
    d: "M318.269 42.176a8.03 8.03 0 1 1 .988-.988l5.165 5.163a.7.7 0 0 1-.988.988Zm0-1.979a6.634 6.634 0 1 0-.987.987 6.7 6.7 0 0 0 .987-.987"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    fill: "#b1b1b1",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(388.581 43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50.61,
    y: 0
  }, "Search with data"))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(785 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 137,
    height: 50,
    fill: "#ebebeb",
    rx: 10
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 14,
    fontWeight: 300,
    transform: "translate(53 22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Richard ")), /*#__PURE__*/React.createElement("text", {
    fill: "#7e7e7e",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 12,
    fontWeight: 300,
    transform: "translate(53 38)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Director")), /*#__PURE__*/React.createElement("path", {
    d: "M123.888 28.076a.66.66 0 0 1-.45-.18l-6.085-5.776a.65.65 0 1 1 .893-.943l5.641 5.353 5.638-5.353a.65.65 0 1 1 .894.943l-6.082 5.776a.65.65 0 0 1-.45.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a2a2a2",
    fillRule: "evenodd",
    d: "M40.368 3.998a6.14 6.14 0 0 1 6.138 6.138v30.33a6.14 6.14 0 0 1-6.138 6.138H10.04a6.14 6.14 0 0 1-6.14-6.138V10.139a6.14 6.14 0 0 1 6.14-6.141Zm-10.595 20.94a14.97 14.97 0 0 1 9.744 10.124v.005a3.97 3.97 0 0 1-3.826 5.037c-5.281 0-15.7 0-20.983-.043a3.93 3.93 0 0 1-3.776-4.981 14.85 14.85 0 0 1 9.7-10.142 7.943 7.943 0 1 1 9.137 0ZM25.2 26.384a12.65 12.65 0 0 0-12.181 9.274 1.762 1.762 0 0 0 1.7 2.234h.009c5.278.043 15.689.043 20.967.043a1.806 1.806 0 0 0 1.741-2.288 12.744 12.744 0 0 0-12.228-9.265Zm0-2.167a5.777 5.777 0 1 0-5.777-5.777 5.78 5.78 0 0 0 5.777 5.777"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#eaeaea",
    transform: "translate(725.169 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    fill: "#f05a5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M759.972 44.604a1.42 1.42 0 0 1-1.412 1.415h-16.788a1.4 1.4 0 0 1-1.415-1.339 3.5 3.5 0 0 1 3.2-3.561v-4.412a6.6 6.6 0 0 1 6.52-6.627h.139a6.6 6.6 0 0 1 6.563 6.627v4.412a3.5 3.5 0 0 1 3.193 3.485M751.807 48.427h-3.279a.67.67 0 1 1 0-1.339h3.279a.67.67 0 1 1 0 1.339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.168 31.208a.67.67 0 0 1-.67-.661v-1.675a.67.67 0 0 1 1.339 0v1.674a.67.67 0 0 1-.669.662"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resQ_Slider4_svg__i)",
    style: {
      isolation: "isolate"
    },
    transform: "translate(3.472 55.524)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#resQ_Slider4_svg__m)",
    style: {
      isolation: "isolate"
    },
    transform: "translate(.999 1)"
  }, _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    fill: "#8b8c8f",
    fontFamily: "Poppins-Bold, Poppins",
    fontSize: 7,
    fontWeight: 700,
    letterSpacing: ".092em",
    transform: "translate(0 6.573)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Target Right, Gain Insight"))))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M12.232 27.218a13.8 13.8 0 0 1 3.461-5.588 7.08 7.08 0 0 1 4.835-1.788 3 3 0 0 1 .467.028 3 3 0 0 0 .412.028 16 16 0 0 0-.247 1.76q-.082.935-.082 2.2v2.7a8 8 0 0 0 .055.935l-.495.44a6 6 0 0 0-1.236-.55 5.1 5.1 0 0 0-1.566-.22 4.93 4.93 0 0 0-3.9 1.623 5.6 5.6 0 0 0-1.429 3.823v2.2q0 3.355.082 6.326t.357 5.721a12 12 0 0 0-1.786-.11H6.517a13 13 0 0 0-1.813.11q.275-2.75.357-5.721t.082-6.326v-2.2q0-3.355-.082-6.3t-.357-5.912q.934.11 1.9.193t1.9.083 1.9-.083 1.9-.193l-.165 6.711Zm20.5 6.491a18.5 18.5 0 0 0 .432 4.121 10.3 10.3 0 0 0 1.346 3.328 6.6 6.6 0 0 0 2.308 2.2 6.5 6.5 0 0 0 3.269.8 10.26 10.26 0 0 0 6.758-2.475l.659.5-1.205 3.077a11.2 11.2 0 0 1-3.3 1.678 16.6 16.6 0 0 1-5.055.633 17.3 17.3 0 0 1-5.11-.743 10.9 10.9 0 0 1-4.256-2.448 12 12 0 0 1-2.914-4.318 16.4 16.4 0 0 1-1.071-6.243 18.2 18.2 0 0 1 .962-6.216 12.3 12.3 0 0 1 2.665-4.4 10.9 10.9 0 0 1 4.039-2.64 14.3 14.3 0 0 1 5.083-.88q5.44 0 8.324 3.19t2.885 9.021v1.155a2.5 2.5 0 0 1-.055.66Zm8.457-2.479a21.3 21.3 0 0 0-1.017-6.6q-.907-2.475-3.05-2.475a2.76 2.76 0 0 0-2.033.825 6 6 0 0 0-1.319 2.118 14 14 0 0 0-.742 2.915 28 28 0 0 0-.3 3.218Zm12.857 8.856a8.5 8.5 0 0 0 .852 1.678 6.4 6.4 0 0 0 1.291 1.43 6.1 6.1 0 0 0 1.841 1.018 7.4 7.4 0 0 0 2.5.385 4.14 4.14 0 0 0 2.967-.99 2.93 2.93 0 0 0 1.044-2.145 2.5 2.5 0 0 0-.934-2.035 10.4 10.4 0 0 0-2.335-1.4q-1.4-.633-3.05-1.293a14 14 0 0 1-3.05-1.678 8.7 8.7 0 0 1-2.335-2.558 7.55 7.55 0 0 1-.934-3.96 8.7 8.7 0 0 1 .852-3.988 8.05 8.05 0 0 1 2.225-2.75 9.4 9.4 0 0 1 3.1-1.6 11.8 11.8 0 0 1 3.434-.523 11.8 11.8 0 0 1 4.094.66 17.2 17.2 0 0 1 3.656 1.93 15 15 0 0 0-.822 2.363 21 21 0 0 0-.495 2.475h-1.538a7.7 7.7 0 0 0-.545-1.455 6.2 6.2 0 0 0-1.044-1.513 5.5 5.5 0 0 0-1.593-1.183 5 5 0 0 0-2.253-.468 4.37 4.37 0 0 0-2.775.88 2.79 2.79 0 0 0-1.126 2.31 2.61 2.61 0 0 0 .962 2.118 9.6 9.6 0 0 0 2.39 1.4q1.429.605 3.132 1.21a14 14 0 0 1 3.132 1.568 8.2 8.2 0 0 1 2.39 2.5 7.37 7.37 0 0 1 .962 3.96 9.1 9.1 0 0 1-.879 4.153 8.2 8.2 0 0 1-2.363 2.86 9.5 9.5 0 0 1-3.385 1.63 15.7 15.7 0 0 1-3.984.5 13 13 0 0 1-4.451-.715 14.8 14.8 0 0 1-3.131-1.49 29.3 29.3 0 0 0 .824-5.281Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#resQ_Slider4_svg__n)",
    d: "M108.812 20.656c-.551-3.812 3.176-7.239 7.9-4.152 4.584 7.835 2.717 13.468 0 21.278 3.756 3.784 3.529 3.125 6.2 6.346.6 3.67-.843 7.224-6.731 5.646-3.9-4.138-.906-.906-4.99-5.183-11.875 7.527-32.72 6.918-37.791-13.178C72.106 21.1 75.269 7.75 95.754 4.679c9.155-.9 7.839 9.2 1.959 8.965-2.29-.214-14.539 2.436-14.524 11.956s7.683 16.088 14.523 15.088 15.271-6.32 11.1-20.032",
    transform: "translate(3 1)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#ebebeb",
    transform: "translate(605.307 13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M628.617 38.357a6.7 6.7 0 0 0-1.586 1.166c-.464.414-2.5 2.644-3.2 3.482-1.007 1.214-.959 1.14-1.068-.339-.028-.383-.1-.761-.145-1.142-.064-.5-.243-.933-.763-1-.848-.109-1.548.082-1.548.8 0 1.869.209 3.619.37 5.514.028.332.013.75.281.986.335.287 1.211.188 1.742.163a29 29 0 0 0 4.708-.494c.745-.205.74-.812.7-1.42-.018-.271-.191-.806-.636-.827-.679-.032-1.4-.008-1.953 0-.445.006-.591-.042.181-.819 1.1-1.105 2.277-2.173 3.27-3.374a3.16 3.16 0 0 0 .817-1.271c.115-.654-.377-1.725-1.17-1.425m12.214-11.108c-.216-.265-.657-.36-2.81-.076a25.5 25.5 0 0 1-3.837.249c-.642-.013-.9.776-.938 1.289a.77.77 0 0 0 .241.677 2.7 2.7 0 0 0 1.262.274c.453.046.908.063 1.361.1-.558.626-1.306 1.527-1.566 1.818-.8.888-1.36 1.565-2.133 2.473-.387.454-1.011 1.057-.752 1.712a1.143 1.143 0 0 0 1.476.558 13 13 0 0 0 2.056-1.7c.64-.619 1.092-1.191 1.7-1.844.317-.342.678-.806 1.05-1.159l.125 1.532c.1 1.174.842 1.2 1.579 1.177.546-.014.787-.385.914-1 .107-.516.168-2.744.307-4.219.041-.496.201-1.568-.035-1.861M632.646 38.357a6.7 6.7 0 0 1 1.59 1.166c.464.414 2.5 2.644 3.2 3.482 1.007 1.214.959 1.14 1.068-.339.028-.383.1-.761.145-1.142.064-.5.243-.933.763-1 .848-.109 1.548.082 1.548.8 0 1.869-.209 3.619-.37 5.514-.028.332-.013.75-.281.986-.335.287-1.211.188-1.742.163a29 29 0 0 1-4.708-.494c-.745-.205-.74-.812-.7-1.42.018-.271.191-.806.636-.827.679-.032 1.4-.008 1.953 0 .445.006.591-.042-.181-.819-1.1-1.105-2.277-2.173-3.27-3.374a3.16 3.16 0 0 1-.817-1.271c-.119-.654.373-1.725 1.166-1.425m-12.215-11.108c.216-.265.657-.36 2.81-.076a25.5 25.5 0 0 0 3.837.249c.642-.013.9.776.938 1.289a.77.77 0 0 1-.241.677 2.7 2.7 0 0 1-1.262.274c-.453.046-.908.063-1.361.1.558.626 1.306 1.527 1.566 1.818.8.888 1.36 1.565 2.133 2.473.387.454 1.011 1.057.752 1.712a1.143 1.143 0 0 1-1.476.558 13 13 0 0 1-2.056-1.7c-.64-.619-1.092-1.191-1.7-1.844-.317-.342-.678-.806-1.05-1.159l-.125 1.532c-.1 1.174-.842 1.2-1.579 1.177-.546-.014-.787-.385-.914-1-.107-.516-.168-2.744-.307-4.219-.04-.496-.2-1.568.035-1.861"
  })));
};
export default SvgResQSlider4;